import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100% !important',
    maxWidth: contentMaxWidth,
    margin: 0,
    marginTop: 16,
    padding: '1rem 1.25rem',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    borderRadius: '1rem',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
  },

  description: {
    textAlign: 'left',
    fontFamily: 'Nunito',
    fontWeight: '400',
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: '#191C1A',
  },

  certificateContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },

  certificate: {
    textAlign: 'left',
    fontFamily: 'Nunito',
    fontWeight: '700',
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: '#191C1A',
  },

  buttonDescription: {
    textAlign: 'left',
    fontFamily: 'Sora',
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '26px',
  },
}))

export { useStyles }
